var registeredUserId = "";
if (document.getElementById('shopify-section-mlb-buy-widget-cerveza')) {
  document.getElementById('shopify-section-mlb-buy-widget-cerveza').style.display='none'; //to hide Product locator
}
if (document.getElementById('shopify-section-mlb-connect-with-us')) {
  document.getElementById('shopify-section-mlb-connect-with-us').style.display='none'; //to hide Social Connect
}
window.APP = {
  init: function () {
    this.formatDate()
    this.validateForm()
  },

  formatDate: function () {
    var date = document.getElementById('dob');

    function checkValue(str, max) {
      if (str.charAt(0) !== '0' || str == '00') {
        var num = parseInt(str);
        if (isNaN(num) || num <= 0 || num > max) num = 1;
        str = num > parseInt(max.toString().charAt(0)) && num.toString().length == 1 ? '0' + num : num.toString();
      };
      return str;
    };

    date.addEventListener('input', function (e) {
      this.type = 'text';
      var input = this.value;
      if (/\D\/$/.test(input)) input = input.substr(0, input.length - 3);
      var values = input.split('/').map(function (v) {
        return v.replace(/\D/g, '')
      });
      if (values[0]) values[0] = checkValue(values[0], 12);
      if (values[1]) values[1] = checkValue(values[1], 31);
      var output = values.map(function (v, i) {
        return v.length == 2 && i < 2 ? v + ' / ' : v;
      });
      this.value = output.join('').substr(0, 14);
    });

    date.addEventListener('blur', function (e) {
      this.type = 'text';
      var input = this.value;
      var values = input.split('/').map(function (v, i) {
        return v.replace(/\D/g, '')
      });
      var output = '';

      if (values.length == 3) {
        var year = values[2].length !== 4 ? parseInt(values[2]) + 2000 : parseInt(values[2]);
        var month = parseInt(values[0]) - 1;
        var day = parseInt(values[1]);
        var d = new Date(year, month, day);
        if (!isNaN(d)) {
          this.innerText = d.toString();
          var dates = [d.getMonth() + 1, d.getDate(), d.getFullYear()];
          output = dates.map(function (v) {
            v = v.toString();
            return v.length == 1 ? '0' + v : v;
          }).join(' / ');
        };
      };
      this.value = output;
    });


  },

  validateForm: function () {
    $.validator.addMethod("mustBe", function (value, element, min) {
    
      var today = new Date();
      var formattedValue = value.split(' / ').join('/');
      var birthDate = new Date(formattedValue);
      var age = today.getFullYear() - birthDate.getFullYear();

      if (age > min + 1) {
        return true;
      }

      var m = today.getMonth() - birthDate.getMonth();

      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }

      return age >= min;
    }, "You must be at least 21 years old to enter");

    $.validator.addMethod("zipcode", function(value, element) {
      return this.optional(element) || /^\d{5}(?:-\d{4})?$/.test(value);
    }, "Please provide a valid zipcode");

    $.validator.addMethod("emailValidate", function(value, element) {
      return this.optional(element) || /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/i.test(value);
    }, "Please provide a valid email address");

    $.validator.addMethod(
      "maxAgeCinco",
      function (value, element, max) {
        var date = value.split("/");
        var m = parseInt(date[0], 10),
          d = parseInt(date[1], 10),
          y = parseInt(date[2], 10);
  
        return y >= max;
      },
      "Please enter a valid year."
    );
  }
}

$(function () {
  //$('.promo-entry__form-wrap.address').hide();
  APP.init();
  $(document).on("keyup", "#phone", function(e){
    var ASCIICode = (e.which) ? e.which : e.keyCode
    var val = this.value;
    if(val.length == 3){
      if(ASCIICode == 8){
        $(this).val(val.substring(0, val.length - 1));
      }else{
        this.value = val+'-';
      }
      
    }else if(val.length == 7){
      if(ASCIICode == 8){
        $(this).val(val.substring(0, val.length - 1));
      }else{
        this.value = val+'-';
      }
    }
  });

  $(document).on("keydown", "#phone", function(e){
    var ASCIICode = (e.which) ? e.which : e.keyCode
    if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57))
        return false;
  });

  $(document).on("keydown", "#zip", function(e){
    var ASCIICode = (e.which) ? e.which : e.keyCode
    if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57))
        return false;
  });
});
//Render Google V2 recpatcha
     
var onloadCallback = function() {
  grecaptcha.render('html_element_notify', {
    'sitekey' : '6LcD3IsgAAAAAGc8LKbShuOF-H6JQXVGlasXJNyA'
  });
  grecaptcha.render('html_element', {
    'sitekey' : '6LcD3IsgAAAAAGc8LKbShuOF-H6JQXVGlasXJNyA'
  });
};

// callback for recaptcha/form submission, must be outside of APP
// function onSubmit() {
// } 
$(document).ready(function(){
  var language = $('.ly-custom-dropdown-current-inner').html().trim();
  var minAgeMssg;
  var minAgeRequiredMssg;
  var emailRequiredMssg;
  var invalidEmailMssg;
  var firstNameRequiredMssg;
  var lastNameRequiredMssg;
  var optinRulesMssg;
  var shortmsg;
  var tshirtmsg;
    if (language === 'ES' || language === "Español") {
      var minAgeMssg = "Debes tener al menos 21 años para ingresar";
      var maxAgeMssg = "Por favor, introduzca un año válido";
      var minAgeRequiredMssg = "Introduzca su fecha de nacimiento";
      var emailRequiredMssg = "Dirección de correo electrónico: obligatorio";
      var invalidEmailMssg = "Dirección de correo electrónico inválida";
      var firstNameRequiredMssg = "Primer nombre requerido";
      var lastNameRequiredMssg = "Apellido Obligatorio";
      var optinRulesMssg = "Comprueba que estás de acuerdo con las reglas oficiales";
      var stateSelectionMssg = "Selecciona un Estado";
      var shortmsg = "Selecciona un Shorts Tipo Bermuda" ;
      var tshirtmsg = "Selecciona un Camiseta";
    } else {
      var minAgeMssg = "You must be at least 21 years old to enter";
      var maxAgeMssg = "Please enter a valid year";
      var minAgeRequiredMssg = "Enter your date of birth";
      var emailRequiredMssg = "Email address required";
      var invalidEmailMssg = "Invalid email address";
      var firstNameRequiredMssg = "First name required";
      var lastNameRequiredMssg = "Last name required";
      var optinRulesMssg = "Please check that you agree to the official rules";
      var stateSelectionMssg = "Select a state";
      var shortmsg = "Select a board shorts" ;
      var tshirtmsg = "Select a t-shirt";
    }

  $("#submissionForm").validate({
    rules: {
      dob: {
        required: true,
        mustBe: 21,
        maxAgeCinco: 1910
      },
      email: {
        required: true,
        emailValidate: true
      }
    },
    messages: {
      dob: {
        mustBe: minAgeMssg,
        required: minAgeRequiredMssg,
        maxAgeCinco: maxAgeMssg
      },
      email: {
        required: emailRequiredMssg,
        emailValidate: invalidEmailMssg
      },
      first_name: firstNameRequiredMssg,
      last_name: lastNameRequiredMssg,
      state: stateSelectionMssg,
      optin_rules: optinRulesMssg
    },
    submitHandler: function () {
      var inputs = $("#submissionForm").serializeArray();
      var final_values = {};
      
      $.each(inputs, function (index, value) {
        if(value['name'] == 'dob') {
          var dobArr = value['value'].split(' / ').join('/');
          final_values['dob'] = dobArr;
        }
        else {
          final_values[value['name']] = value['value'];
        }
      });
      final_values['language'] = language;
      final_values['optin_rules'] = true;
      if(final_values['optin_rules_legal'] == "on"){
        final_values['optin_contact'] = true;
        delete final_values['optin_rules_legal'];
      }
      var captcha_resp = grecaptcha.getResponse(1);
      if(captcha_resp != '' && captcha_resp != null){
        final_values['g-recaptcha-response'] = captcha_resp;
          var data = JSON.stringify(final_values);
          //console.log(data);
          // debugger;
          var settings = {
            "url": "https://coronafallfootball2022.api.dja.com/production/registration",
            "method": "POST",
            "headers": {
              "Authorization": "Bearer $2y$10$0oywe7jkX0i953KShm9DaO.26UzRhoCa.tsMzQ9OyubKLZBo//qXe",
              "Content-Type": "application/json"
            },
            "dataType": "json",
            "data": data
          };
          $.ajax(settings).done(function (responseData) {
          
          var response = responseData;
            var cleanResponse = '';
            var showSuccess = false;
            var showmainSuccess = false;
            var errorMessage;
            var winner = false;
            var showLocator = false;

            if (language === 'ES' || language === "Español") {
              var errorMessage = 'Perdón, algo salió mal.<br>Inténtalo de nuevo.'
            } else {
              var errorMessage = 'Sorry, something went wrong.<br>Please try again.';
            }
           
          if(getUrlParameter('status')){   
          var responseVar = getUrlParameter('status');
          var responseMsg = getUrlParameter('msg');
          }
          else
          {
           var responseVar = response.status;
            var responseMsg = response.redirect;
          }
          
            // console.log("response status=="+ responseVar);
            //  console.log("response message=="+ responseMsg);
            //  console.log("response of success=="+response.data.winner);
           
            switch (responseVar) {
              case "Missing Token":
                cleanResponse = errorMessage;
                break;
              case "Token Not Valid":
                cleanResponse = errorMessage;
                break;
              case "bad_request":
                cleanResponse = errorMessage;
                break;
              case "redirect":
                if( responseMsg == "already_entered" ) { 
                    if (language === 'EN' || language === 'English') {
                      cleanResponse = "SORRY! IT LOOKS LIKE YOU’VE ALREADY ENTERED TODAY.<br><br><p class='subtext-descp'>COME BACK AND ENTER EVERY DAY<br>THROUGH OCTOBER 31, 2022.</p>";
                    } else {
                      cleanResponse = "¡LO SENTIMOS! PARECE QUE YA HAS ENTRADO HOY.<br><br><p class='subtext-descp'>PUEDES VOLVER Y ENTRAR TODOS LOS DÍAS <br>HASTA EL 31 DE OCTUBRE DE 2022.</p>";
                    }  
                }
                else if( responseMsg == "thank_you_nj" ) {
                    if (language === 'EN' || language === 'English') {
                      cleanResponse = "<h2 class='thanku-resp'>THANK YOU FOR ENTERING!</h2><p class='subtext-descp'>COME BACK AND ENTER EVERY DAY<br>THROUGH OCTOBER 31, 2022.</p>";
                    } else {
                      cleanResponse = "<h2 class='thanku-resp'>¡GRACIAS POR ENTRAR!</h2><p class='subtext-descp'>PUEDES VOLVER Y ENTRAR TODOS LOS DÍAS <br>HASTA EL 31 DE OCTUBRE DE 2022.</p>";
                    }
                }
                else if( responseMsg == "already_played" ) {
                    
                    if (language === 'EN' || language === 'English') {
                      cleanResponse = "SORRY! IT LOOKS LIKE YOU’VE ALREADY ENTERED TODAY. <br><p class='subtext-descp main'>COME BACK AND ENTER EVERY DAY<br>THROUGH OCTOBER 31, 2022. </p>";
                    } else {
                      cleanResponse = "¡LO SENTIMOS! PARECE QUE YA HAS ENTRADO HOY.<br><br><p class='subtext-descp'>PUEDES VOLVER Y ENTRAR TODOS LOS DÍAS <br>HASTA EL 31 DE OCTUBRE DE 2022.</p>";
                    }
                  }
                else if( responseMsg == "already_won" ) {
                  if (language === 'EN' || language === 'English') {
                    cleanResponse = "IT LOOKS LIKE YOU’VE ALREADY WON AN INSTANT WIN GAME PRIZE <br> BUT YOU’VE BEEN ENTERED INTO <br> THE SWEEPSTAKES GRAND PRIZE DRAWING! <br><p class='already-won-resp'>THERE IS A LIMIT OF ONE (1) INSTANT WIN GAME PRIZE PER PERSON/HOUSEHOLD. <br>SEE <span><a href='/pages/summer-officialrules' target=_blank >OFFICIAL RULES</a> FOR MORE DETAILS.</span></p>";
                  } else {
                    cleanResponse = "PARECE QUE USTED YA HA GANADO UN PREMIO EN EL JUEGO INSTANTÁNEO,  <br> PERO ¡HA OBTENIDO UN REGISTRO PARA <br>PARTICIPAR EN EL SORTEO DE UN GRAN PREMIO! <br><p class='already-won-resp'>HAY UN LÍMITE DE 1 (UN) PREMIO EN EL JUEGO INSTANTÁNEO POR PERSONA U HOGAR. <br> PARA MÁS DETALLES, CONSULTE LAS <span><a href='/pages/summer-officialrules' target=_blank >REGLAS OFICIALES</a>.</span></p>";
                  }
                }
                else if( responseMsg == "over" ) {
                   if (language === 'EN' || language === 'English') {
                     cleanResponse = "Thanks for your interest!<br> SWEEPSTAKES HAS ENDED.";
                  } else {
                    cleanResponse = "GRACIAS POR SU INTERÉS!<br> EL SORTEO HA TERMINADO.";
                 }
                
                  showSuccess = true;
                  break; 
                }
                showSuccess = true;
                showLocator = true;
                break;
              case "success":
                if(getUrlParameter('msg')){
                if(getUrlParameter('msg') == "winner")
                {
                  var responseWinner =  true;
                  $(".form_prize_id").val("9d0827e8-6bee-4fac-b7b3-2646b1f24a4e");
                }
                else if(getUrlParameter('msg') == "non-winner"){
                  var responseWinner =  false;
                }
                else{
                  var responseWinner = response.data.winner ?? false;
                }
                }
                else
                {
                var responseWinner = response.data.winner ?? false;
                }
                if( responseWinner == true ) { 
                  if(getUrlParameter('msg'))
                  {
                    
                  }
                  else
                  {
                  $(".form_prize_id").val(response.data.prize_id);
                  }
                  showSuccess = true;
                  showmainSuccess = true;
                  winner = true;
                  showLocator = false;
                  
                }
                else if( responseWinner == false ) { 
                    if (language === 'EN' || language === 'English') {
                     
                      cleanResponse = "THANK YOU FOR ENTERING! <br><p class='subtext-descp main'>COME BACK AND ENTER EVERY DAY<br>THROUGH OCTOBER 31, 2022.</p>";
                     
                      
                    } else {
                     
                      cleanResponse = "¡GRACIAS POR ENTRAR! <br><p class='subtext-descp main'>PUEDES VOLVER Y ENTRAR TODOS LOS DÍAS <br>HASTA EL 31 DE OCTUBRE DE 2022.</p>";
                      
                    }
                  showSuccess = true;
                  showLocator = true;
                }
                break;
              case "over":

                   if (language === 'EN' || language === 'English') {
                     cleanResponse = "Thanks for your interest!<br> THIS SWEEPSTAKES/INSTANT WIN GAME HAS ENDED.";
                  } else {
                    cleanResponse = "¡GRACIAS POR SU INTERÉS!<br> EL SORTEO/JUEGO INSTANTÁNEO YA HA FINALIZADO.";
                 }
                  
                showSuccess = true;
                break;
            }
            if(showmainSuccess){
              $('.promo-entry__form-wrap').hide();
              $('#promo-entry__success-message1').show();
                $('.promo-entry__headline').hide();
              $('.promo-entry__congrats1').show();
              $('.promo-entry__subhead').hide();
//               $(".promo-entry").addClass("response-msg");
              $('#shopify-section-hero-summer-second').hide();
              $('#shopify-section-hero-evergreen-promo .hero__logo-promo').hide();
              $('#shopify-section-promo-page-intro a.btn').hide();
              
            }
            else if(showSuccess) {
              $('.promo-entry__form-wrap').hide();
              $('#promo-entry__success-message').html(cleanResponse);
              $('.promo-entry__headline').hide();
              $('.promo-entry__subhead').hide();
              $(".promo-entry").addClass("response-msg");
              $('#shopify-section-hero-summer-second').hide();
              $('#shopify-section-hero-evergreen-promo .hero__logo-promo').hide();
              $('#shopify-section-promo-page-intro a.btn').hide();

  
              if (winner) {              
                $('.promo-entry__congrats').show();
                $(".promo-entry").removeClass("response-msg");
              }
              
              $('#form-legal').hide();
              $('html, body').animate({
                scrollTop: $(".contact__form-wrap").offset().top - 100
              }, 500);
            } else {
              $('#promo-entry__error-message').html(errorMessage);
            }
            if(showLocator) {
  
              if (document.getElementById('shopify-section-mlb-buy-widget-cerveza')) {
                document.getElementById('shopify-section-mlb-buy-widget-cerveza').style.display='block'; //to display Product locator
              }
              if (document.getElementById('shopify-section-mlb-connect-with-us')) {
                document.getElementById('shopify-section-mlb-connect-with-us').style.display='block'; //to display Social Connect
              }
            }

        }).fail(function(data) {
            const errors = data.responseJSON.errors
            if( Array.isArray(errors) ){
              let concatFields = '';
              $.each(errors, function( index, value ) {
                ;
                if( ( errors.length - 1) == index ){
                  concatFields += value.replace("_", " ")
                }else{
                  concatFields += value.replace("_", " ") +', ';
                }
                
              });
              var invalidmsg;
              if (language == 'ES') {
                var invalidmsg = 'Campos no válidos enviados : '+ concatFields;
              } else {
                
                var invalidmsg = 'Invalid fields submitted : '+ concatFields;
              }
              $('#promo-entry__error-message').html( invalidmsg ) ;
    
              $('html, body').animate({
                scrollTop: $("#promo-entry__error-message").offset().top - 80
              }, 500);
              $('#promo-entry__error-message').fadeOut(5000);
              $("#captcha-custom-error_main_form").addClass("hide");
            }
            
          });
      }
      else{
        $("#captcha-custom-error_main_form").removeClass("hide");
      }
      return false;
    }
  });
  
});

var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};

$("#submissionForm_enterafter").validate({
    rules: {
      shorts: {
        required: true
      },
      tshirt: {
        required: true
      }
    },
    submitHandler: function () {
      var inputs1 = $("#submissionForm_enterafter").serializeArray();
      
      var final_values1 = {};
      
      $.each(inputs1, function (index, value) {
       
          final_values1[value['name']] = value['value'];
        
      });
      var data1 = JSON.stringify(final_values1);
      //console.log(data1);
	  //debugger;
          var settings1 = {
            "url": "https://coronafallfootball2022.api.dja.com/staging/fulfillment",
            "method": "POST",
            "headers": {
              "Authorization": "Bearer $2y$10$vY4rZr.LjUTJcuXgQeMsjuBYawXIFC6OmtLIHyVDIHJVg97lrxkua",
              "Content-Type": "application/json"
            },
            "dataType": "json",
            "data": data1
          };
        $.ajax(settings1).done(function (responseData1) {
          
          var response = responseData1;
          //console.log(response);
          var responseVar = response.status;
          if(responseVar == "success"){
            $("#promo-entry__success-message1").css("display","none");
            $("#promo-entry__success-message2").css("display"," block");
          }
        });
      
  
    }
});
